import { configureStore } from "@reduxjs/toolkit";
import { baseApi } from "@/core/api/baseApi";
import { publicApi } from "@/core/api/publicApi";
import authReducer from "./slices/authSlice";
import locationsReducer from "./slices/locationsSlice";
import employersReducer from "./slices/employersSlice";
import groupsReducer from "./slices/groupsSlice";
import divisionsReducer from "./slices/divisionsSlice";
import partnersReducer from "./slices/partnersSlice";
import { type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

export const store = configureStore({
  reducer: {
    [baseApi.reducerPath]: baseApi.reducer,
    [publicApi.reducerPath]: publicApi.reducer,
    auth: authReducer,
    locations: locationsReducer,
    employers: employersReducer,
    groups: groupsReducer,
    divisions: divisionsReducer,
    partners: partnersReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(baseApi.middleware, publicApi.middleware),
});

// Dev-only debugging handle: lets a browser console inspect live RTK Query
// state (`__store.getState().api.queries`) without Redux DevTools. Stripped
// from production bundles by the DEV guard.
if (import.meta.env.DEV && typeof window !== "undefined") {
  (window as unknown as { __store?: typeof store }).__store = store;
}

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;
